module.exports = __webpack_public_path__ + "img/3.a8c5d7b3.jpg";